export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12589.fdad10eb.jpg";